import React, { useState } from 'react'

import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import SaveIcon from '@mui/icons-material/Save'
import { useSnackbar } from 'notistack'

const UpdateThirteenthMonthPayButton = ({ onClick }) => {
    let [loading, setLoading] = useState(false)
    const { enqueueSnackbar } = useSnackbar()

    let updateThirteenthMonthPay = async () => {
        try {
            setLoading(true)
            await onClick()
            setLoading(false)
            enqueueSnackbar('13th Month Pay updated successfully.', { variant: 'success' })
        } catch (err) {
            console.error('Failed to update 13th Month Pay', err)
            setLoading(false)
            enqueueSnackbar('Failed to update 13th Month Pay. Please try again.', { variant: 'error' })
        }
    }
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Button
                variant="outlined"
                endIcon={<SaveIcon />}
                onClick={updateThirteenthMonthPay}
                disabled={loading}
                sx={{
                    borderColor: '#12C1DC',
                    color: '#12C1DC',
                    textTransform: 'none',
                    '&:hover': {
                        borderColor: '#0fb8d0',
                        bgcolor: 'rgba(18, 193, 220, 0.1)'
                    }
                }}
            >
                {loading ? 'Updating...' : 'Update 13th Month Pay'}
            </Button>
        </Box>
    )
}

export default UpdateThirteenthMonthPayButton